exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3IVidJ3ki9zBNjZWIt61cG._2hf4-VuN5x5_JjBPdVwf_G{font-size:20px}._3IVidJ3ki9zBNjZWIt61cG._1UpjFqJSNQPnBkilWyzpo-,._3IVidJ3ki9zBNjZWIt61cG._2Zl6MwQ_YLBxAw_4tBB9Sh{font-size:16px}", ""]);
// Exports
exports.locals = {
	"categorySize": "_3IVidJ3ki9zBNjZWIt61cG",
	"full": "_2hf4-VuN5x5_JjBPdVwf_G",
	"compact": "_1UpjFqJSNQPnBkilWyzpo-",
	"medium": "_2Zl6MwQ_YLBxAw_4tBB9Sh"
};